module.exports = __webpack_public_path__ + "img/gyant_light_grey_ba_list.c3647af6.jpg";